export { default } from './ClinicalSummary';
